import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        new_partners: {
          header: 'HEADER',
          reject_btn: 'REJECT_BTN',
          accept_btn: 'ACCEPT_BTN',
          reject_partner: {
            modal_window: {
              title: 'REJECT_TITLE',
              question: 'REJECT_QUESTION',
              answer_no: 'REJECT_NO',
              answer_yes: 'REJECT_YES',
            },
          },
          accept_partner: {
            header: 'ACCEPT_HEADER',
            accept_btn: 'ACCEPT_ACCEPT_BTN',
            button_back: 'ACCEPT_BACK_BTN',
            choose_manager: 'ACCEPT_CHOOSE_MANAGER',
            choose_department: 'ACCEPT_CHOOSE_DEPARTMENT',
            save_department_warning: 'ACCEPT_SAVE_DEPARTMENT_WARNING',
            modal_window: {
              title: 'ACCEPT_MODAL_TITLE',
              question: 'ACCEPT_MODAL_QUESTION',
              answer_no: 'ACCEPT_MODAL_NO',
              answer_yes: 'ACCEPT_MODAL_YES',
            },
          },
        },
      },
    },
  }));
}
